import React, { useState, useEffect } from 'react';
// import { Steps } from '@b-design/fusion';
import { Steps } from 'antd';
import $i18n from '@/i18n';
import Record from './component/record';
import './index.less';

const { Step } = Steps;
interface VersionDescription {
  name: string;
  appId: string;
  iconPublicUrl: string;
  slogan: string;
  description: string;
  customerEmail: string;
  customerPhone: string;
  inherit: boolean;
}
interface App {
  framework: string;
}
interface VersionDetail {
  createName: string;
  modifiedName: string;
  gmtCreate: string;
  gmtModified: string;
  comment: string;
  channelName: string;
  changelog: string;
  version: string;
  appId: string;
  channelCode: string;
  versionStatus: string;
  versionDescription: VersionDescription;
  app: App;
}
interface HistoryList {
  createName: string;
  type: string;
  gmtCreate: string;
  extInfo?: any;
}
interface Props {
  spaceId: string | (string | null)[] | null;
  historyList: HistoryList[];
  versionDetail: VersionDetail;
  initDataSource: () => void;
}

const Release: React.FC<Props> = ({ historyList, versionDetail, initDataSource, spaceId }) => {
  const [currentStep, setCurrentStep] = useState(0);
  const { versionStatus } = versionDetail;

  useEffect(() => {
    getProcess();
  }, [versionStatus]);

  // 根据状态获取对应步骤
  const getProcess = () => {
    if (versionStatus === 'CREATER') {
      setCurrentStep(0);
    } else if (
      versionStatus === 'APPROVE' ||
      versionStatus === 'REJECT' ||
      versionStatus === 'START_APPROVE' ||
      versionStatus === 'WITHDRAW'
    ) {
      setCurrentStep(1);
    } else if (
      versionStatus === 'PASSED' ||
      versionStatus === 'BETA_TEST' ||
      versionStatus === 'BETA_TEST_SUSPEND'
    ) {
      setCurrentStep(2);
    } else if (
      // versionStatus === 'PASSED' ||
      // versionStatus === 'BETA_TEST' ||
      // versionStatus === 'BETA_TEST_SUSPEND' ||
      versionStatus === 'GRAY' ||
      versionStatus === 'GRAY_SUSPEND'
    ) {
      setCurrentStep(3);
    } else if (
      versionStatus === 'ONLINE' ||
      versionStatus === 'OFFLINE' ||
      versionStatus === 'ARCHIVE'
    ) {
      setCurrentStep(4);
    }
  };

  return (
    <div className="release-container">
      <div className="release-container-steps">
        <Steps current={currentStep} size="small">
          <Step
            key={1}
            title={$i18n.get({
              id: 'aopf.pages.miniapp.Version.tabs.Release.Version.Creation',
              dm: '创建版本',
            })}
          />
          <Step
            key={2}
            title={$i18n.get({
              id: 'aopf.pages.miniapp.Version.tabs.Release.Submit.For.Review',
              dm: '提交及审查',
            })}
          />
          <Step
            key={3}
            title={$i18n.get({
              id: 'aopf.pages.miniapp.Version.tabs.Release.Whitelist.Test',
              dm: '白名单测试',
            })}
          />
          <Step
            key={4}
            title={$i18n.get({
              id: 'aopf.pages.miniapp.Version.tabs.Release.Gray.Release',
              dm: '灰度发布',
            })}
          />
          <Step
            key={5}
            title={$i18n.get({
              id: 'aopf.pages.miniapp.Version.tabs.Release.Officially.Release',
              dm: '发布',
            })}
          />
        </Steps>
      </div>
      <Record
        historyList={historyList}
        versionDetail={versionDetail}
        initDataSource={initDataSource}
        spaceId={spaceId || ''}
      />
    </div>
  );
};
export default Release;
